.grid-list-container {
    display: grid;
    grid-auto-rows: max-content;
    grid-gap: 16px;
}
